import { ChevronButtonSC } from './../../../components/chevron-button/chevron-button.styled';
import { InfoWrapperSC } from './../../../auth.styled';
import styled from 'styled-components';
import HeaderSC from '@pages/auth/components/header/header.styled';

export const StepSuccessSC = styled(InfoWrapperSC)`
  .desktop-only {
    grid-row-start: 4;
    grid-column-start: 1;
    grid-column-end: 3;
    align-self: end;
    justify-self: center;
    text-align: center;
    color: #fff;
  }

  grid-template-columns: 0.1fr 4fr;

  @media (min-width: 900px) {
    align-self: flex-start;
    grid-column-start: 2;
    grid-column-end: 4;
    grid-template-columns: 80% 20%;
    grid-template-rows: 25% max-content 25%;
    grid-template-areas: unset;

    .next-button {
      margin-top: 32px;
    }

    ${ChevronButtonSC} {
      grid-area: unset;
      grid-row-start: 3;
      grid-column-start: 1;
      justify-self: flex-end;
    }

    ${HeaderSC} {
      grid-area: unset;
      grid-row-start: 2;
      align-self: flex-start;
      max-width: 100%;
    }
  }

  h1 {
    text-align: left;
  }
`;
